import React from "react";
import AppleIcon from "./../assets/icons/apple.png";
import GoogleIcon from "./../assets/icons/google.png";
import SpotifyIcon from "./../assets/icons/spotify.png";
import AnchorIcon from "./../assets/icons/anchor.png";

const EpisodeCard = ({
  serialNo,
  imageUrl,
  title,
  applePodcastUrl,
  googlePodcastUrl,
  spotifyPodcastUrl,
  anchorPodcastUrl,
}) => {
  return (
    <div className="w-full lg:w-[22rem] rounded-xl shadow-md mt-10">
      <img
        src={imageUrl}
        alt={`Poster of - ${title}`}
        className="w-full lg:w-[22rem] h-80 rounded-t-md"
      />
      <div className="p-4 mb-5">
        <h4 className="mt-4 font-bold text-lg">
          Episode {serialNo}: {title}
        </h4>
        <div className="mt-4">
          <a
            href={applePodcastUrl}
            target="_blank"
            rel="noreferrer"
            className="flex justify-center gap-2 rounded-full shadow text-center p-1.5 border text-sm"
          >
            <img src={AppleIcon} alt="" className="w-6 h-6" />
            Listen on Apple Podcast
          </a>
        </div>
        <div className="mt-4">
          <a
            href={googlePodcastUrl}
            target="_blank"
            rel="noreferrer"
            className="flex justify-center gap-2 rounded-full shadow text-center p-1.5 border text-sm"
          >
            <img src={GoogleIcon} alt="" className="w-6 h-6 " />
            Listen on Google Podcast
          </a>
        </div>
        <div className="mt-4">
          <a
            href={spotifyPodcastUrl}
            target="_blank"
            rel="noreferrer"
            className="flex justify-center gap-2 rounded-full shadow text-center p-1.5 border text-sm"
          >
            <img src={SpotifyIcon} alt="" className="w-6 h-6" />
            Listen on Spotify Podcast
          </a>
        </div>
        <div className="mt-4">
          <a
            href={anchorPodcastUrl}
            target="_blank"
            rel="noreferrer"
            className="flex justify-center gap-2 rounded-full shadow text-center p-1.5 border text-sm"
          >
            <img src={AnchorIcon} alt="" className="w-6 h-6" />
            Listen on Anchor Podcast
          </a>
        </div>
      </div>
    </div>
  );
};

export default EpisodeCard;
